import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../shared/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import styles from './styles.scss';

class UncertaintyCalculation extends React.Component {
  render() {
    const { isChecked, onToggle } = this.props;
    return (
      <Card>
        <div className={styles.switchContainer}>
          <p className={styles.switchDisplayText}>Display Uncertainty Calculation with Results</p>
          <label className={styles.switch}>
            <input type="checkbox" checked={isChecked} onChange={onToggle} />
            <span className={`${styles.slider} ${styles.round}`}></span>
          </label>
        </div>
      </Card>
    );
  }
}

UncertaintyCalculation.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default UncertaintyCalculation;



// WEBPACK FOOTER //
// src/components/reportManagement/UncertaintyCalculation/index.jsx